import React from 'react';
import PropTypes from 'prop-types';

import {
  Accordion,
} from './styles';

import TranscriptTimeOnTask from './transcript-time-on-task';
import Range from '../transcripts/answerTranscript/range';

const RangeQuestion = (props) => {
  const {
    question,
    active,
    answer,
    onSubmit,
    timeOnTask,
    onRemoveTagHighlight,
    index,
  } = props;

  const key = answer.questionId ? answer.questionId : index;

  return (
    <Accordion.Content
      active={active}
      key={question.id + question.groupId}
    >

      <Range
        options={question.questionOptions && question.questionOptions.length}
        parentKey={key}
        questionId={answer.questionId}
        checked={answer.valueInteger}
      />

      <TranscriptTimeOnTask
        answer={answer}
        timeOnTask={timeOnTask}
        onSubmit={(value) => onSubmit(value, answer.id)}
        onRemoveTagHighlight={onRemoveTagHighlight}
      />
    </Accordion.Content>
  );
};

RangeQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  answer: PropTypes.object.isRequired,
  active: PropTypes.bool,
  onSubmit: PropTypes.func.isRequired,
  onRemoveTagHighlight: PropTypes.func.isRequired,
  timeOnTask: PropTypes.node.isRequired,
  index: PropTypes.number.isRequired,
};

RangeQuestion.defaultProps = {
  active: false,
};

export default RangeQuestion;
